module.exports = __webpack_public_path__ + "static/postman-9ae8ceaa543d93d321a63d4f6f1b120d.png";